// Copyright 2024 Vajra. All rights reserved.
// Telemetry Page

export default function TelemetryPage() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Telemetry</h1>
      <p className="mt-2 text-sm text-gray-700">
        Monitor events and security metrics.
      </p>
      {/* Telemetry dashboard would go here */}
    </div>
  );
}
